// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const AlertDialogBody = createStyle({
  px: '$4',
  py: '$2',
});
